import { apiFetch } from './client';

export type Severity = 'URGENT' | 'ATTEND' | 'WATCH' | 'ROUTINE' | 'INFO';

export type FindingStatus = 'ACTIVE' | 'STABLE' | 'RESOLVING' | 'RESOLVED';

export interface Finding {
  dimension: string;
  kind: string;
  agent_id: string;
  severity: Severity;
  headline: string;
  evidence: Array<Record<string, unknown>>;
  suggestion: string;
  subject_key: string;
  status: FindingStatus;
  first_seen_ms: number | null;
  last_seen_ms: number | null;
  resolved_ms: number | null;
  fingerprint: string;
}

export interface FindingsResponse {
  count: number;
  by_severity: Record<string, number>;
  by_dimension: Record<string, number>;
  findings: Finding[];
}

export function fetchFindings(
  opts: {
    status?: 'active' | 'all' | 'resolved';
    dimension?: string;
    severity?: Severity;
  } = {},
): Promise<FindingsResponse> {
  const params = new URLSearchParams();
  if (opts.status) params.set('status', opts.status);
  if (opts.dimension) params.set('dimension', opts.dimension);
  if (opts.severity) params.set('severity', opts.severity);
  const qs = params.toString();
  return apiFetch<FindingsResponse>(
    `/api/findings${qs ? `?${qs}` : ''}`,
  );
}
